export default __webpack_public_path__ + "b71a61e0d4b9370d6442fb666ceea723.png";